import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import TextFieldWithSetValue from "../../../../textfield/TextFieldWithSetValue";
import MaterialOptimizationTextFieldObjectWithEntityList
    from "../../../../textfield/MaterialOptimizationTextFieldObjectWithEntityList";
import CurrencyTextFieldObjectWithEntityList from "../../../../textfield/CurrencyTextFieldObjectWithEntityList";
import TextFieldSimpleSupplierMaterial from "../supplier/TextFieldSimpleSupplierMaterial";
import TextFieldWithSetValueMainOptions from "../../../../modul/mainoptions/TextFieldWithSetValueMainOptions";
import MaterialTextFieldObjectWithEntityList from "../../../../modul/mainoptions/MaterialTextFieldObjectWithEntityList";
import {statusesYesOrNo} from "../../../../../../data/StatusesYesOrNo";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";

const ModalCreateOrUpdateMaterialStripe = ({
                                               open,
                                               onClose,
                                               title,
                                               values,
                                               setValues,
                                               labelButtonSSubmit,
                                               handleSubmit,
                                               supplierList,
                                               setSupplierId,
                                               price,
                                               setPrice,
                                               currencyMap,
                                               setCurrencyId,
                                               isNew,
                                               isFixPrice,
                                               loading
                                           }) => {
    const currencyList = Array.from(currencyMap.values())
    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent sx={{padding: "24px"}}>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            minHeight: "750px",
                            width: '100%',
                            minWidth: {xs: '300px', sm: '360px', md: '400px'},
                            gap: '0.01rem',
                        }}
                    >
                        {isNew && <MaterialOptimizationTextFieldObjectWithEntityList
                            label="Поставщик"
                            field={'material'}
                            setId={setSupplierId}
                            entityList={supplierList}
                        />}
                        <TextFieldWithSetValueMainOptions
                            label="Артикул поставщика"
                            values={values}
                            setValues={setValues}
                            field={'article'}
                        />
                        <TextFieldWithSetValueMainOptions
                            label="Наименоваание поставщика"
                            values={values}
                            setValues={setValues}
                            field={'materialNameSupplier'}
                        />
                        <TextFieldWithSetValue
                            label="Ширина"
                            values={values}
                            setValues={setValues}
                            field={'length'}
                            disabled={!isNew}
                        />
                        <TextFieldWithSetValue
                            label="Высота"
                            values={values}
                            setValues={setValues}
                            field={'width'}
                            disabled={!isNew}
                        />
                        <TextFieldWithSetValue
                            label="Отступ слева"
                            values={values}
                            setValues={setValues}
                            field={'trimmingLeft'}
                        />
                        <TextFieldWithSetValue
                            label="Отступ справа"
                            values={values}
                            setValues={setValues}
                            field={'trimmingRight'}
                        />
                        <TextFieldWithSetValue
                            label="Отступ сверху"
                            values={values}
                            setValues={setValues}
                            field={'trimmingTop'}
                        />
                        <TextFieldWithSetValue
                            label="Отступ снизу"
                            values={values}
                            setValues={setValues}
                            field={'trimmingBottom'}
                        />
                        <CurrencyTextFieldObjectWithEntityList
                            label="Валюта базовой цены"
                            values={values}
                            field={'basePrice'}
                            setId={setCurrencyId}
                            entityList={currencyList}
                            disabled={!isNew}
                        />
                        {isNew && <TextFieldSimpleSupplierMaterial
                            label="Базовая цена"
                            value={price}
                            setValue={setPrice}
                            field={'price'}
                        />}
                        {!isNew && <TextFieldWithSetValueMainOptions
                            label="Базовая цена"
                            values={values ? values.basePrice : null}
                            setValues={setValues}
                            field={'price'}
                            disabled={true}
                        />}
                        {isFixPrice && <MaterialTextFieldObjectWithEntityList
                            label="Фиксированная цена"
                            values={values}
                            setValues={setValues}
                            field={'fixPrice'}
                            entityList={statusesYesOrNo}
                        />}
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Выйти"} onClick={onClose}/>
                <ButtonAdd loading={loading} text={labelButtonSSubmit} onClick={handleSubmit}/>
            </DialogActions>
        </Dialog>
    );
};

export default ModalCreateOrUpdateMaterialStripe;